import { Box, styled, Typography } from '@mui/material';

import { theme } from 'styles';

export const InputW = styled(Box)`
  width: 47%;
  @media (max-width: 1023px) {
    width: 100%;
  }
`;

export const WranDescription = styled(Typography)`
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: ${theme.palette.info.main};
`;

export const SliderLabel = styled(Typography)`
  font-size: 18px;
  line-height: 18px;
  @media (max-width: 1023px) {
    font-size: 12px;
    line-height: 16px;
  }
`;
